import { withDetailView } from '@components/enitity/detail/Detail.view'
import { ChatList } from '@features/chat/components/chat-list/ChatList.tsx'
import { ChatModal } from '@features/chat/components/chat-list/ChatModal'
import { useCreateChat } from '@services/chat/mutations/useCreateChat'
import { useUpdateChat } from '@services/chat/mutations/useUpdateChat'
import { useChat } from '@services/chat/queries/useChat'
import { useClients } from '@services/users/queries/useClients'
import { Loader2 } from 'lucide-react'
import { useEffect, useState } from 'react'

import { Combobox } from '@/components/ui/combobox'

import { ChatDetailComponent } from '../components/chat-detail/ChatDetailComponent'
import { useChatWidgetContext } from '../context'
import './Chat.scss'

const UserSelect = (props: { setActiveUser: (user: string) => void }) => {
  const users = useClients()

  return (
    <Combobox
      className="w-48"
      onChange={(value) => value && props.setActiveUser(value)}
      options={
        users.data?.results
          .filter((user) => user.id)
          .map((user) => ({
            label: `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim(),
            value: user.id!
          })) ?? []
      }
    />
  )
}

export function ChatContent(props: {
  currentUser?: string
  userSelect?: boolean
}) {
  const { activeChat, setActiveChat } = useChatWidgetContext()
  const [activeUser, setActiveUser] = useState<string | undefined>(
    props.currentUser
  )
  const createChat = useCreateChat<'ADMIN'>()
  const updateChat = useUpdateChat()
  const chat = useChat(activeChat ?? '')

  useEffect(() => {
    setActiveUser(props.currentUser)
  }, [props.currentUser])

  const selectChat = (id?: string) => {
    setActiveChat(id)
  }

  return (
    <>
      {props.userSelect && <UserSelect setActiveUser={setActiveUser} />}

      <div style={{ padding: props.userSelect ? 10 : 0 }}>
        {!activeChat && (
          <ChatList
            selectChat={selectChat}
            activeChat={activeChat}
            activeUser={activeUser}
            modal={
              <ChatModal
                user_id={activeUser}
                createChat={createChat}
                updateChat={updateChat}
              />
            }
          />
        )}
        {activeChat &&
          (chat.data ? (
            <ChatDetailComponent
              data={chat.data}
              user_id={activeUser}
              onBack={() => setActiveChat(undefined)}
            />
          ) : (
            <div className="flex items-center justify-center py-16">
              <Loader2 className="h-10 w-10 animate-spin text-primary" />
            </div>
          ))}
      </div>
    </>
  )
}

export const Chat = withDetailView(
  () => ChatContent({ userSelect: true }),
  'Chat'
)
